import { useState } from 'react';
// @mui
import { Box, Table, TableBody, TableContainer, Typography, Stack, styled, Divider, useTheme } from '@mui/material';

import useTable from '../../hooks/useTable';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { TableNoData, TableSkeleton, TableHeadCustom } from '../../components/table';

import MyDownlineTableRow from './MyDownlineTableRow';
import useLocales from '../../hooks/useLocales';

const Title = styled(Typography)(({ theme }) => ({
  color: '#d4af37',
  fontSize: '1.2rem',
  fontWeight: 500,
}));

const _filters = {
  dateFrom: '',
  dateTo: '',
  transactionType: '',
};

const MyDownline = ({ tableData }) => {
  const theme = useTheme();

  const { translate } = useLocales();

  const [filters, setFilters] = useState(_filters);

  const [isLoading, setIsLoading] = useState(false);

  const { dense, order, orderBy, rowsPerPage, onSort } = useTable();

  const denseHeight = dense ? 60 : 80;

  const isNotFound = (!tableData.length && !!filters) || (!isLoading && !tableData.length);

  const TABLE_HEAD = [
    { id: 'tier', label: translate('tier'), align: 'left' },
    { id: 'downline', label: translate('downline'), align: 'left' },
  ];

  return (
    <Page title="My Downline">
      <Box
        component={Stack}
        sx={{ backgroundColor: '#000000' }}
        spacing={2}
        paddingBottom={{ xs: 12, md: 10 }}
        px={{ xs: 2, md: 20 }}
        py={2}
      >
        <Box mb={2}>
          <Box display="flex">
            <Box
              sx={{
                background: theme.palette.goldcity.gradient.main,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }}
              px={2}
              py={0.5}
            >
              <Typography>{translate('downline')}</Typography>
            </Box>
          </Box>
          <Divider sx={{ width: '100%', borderColor: theme.palette.goldcity.border.main }} />
        </Box>

        <Box sx={{ mt: 3, width: '100%' }}>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 400, position: 'relative' }}>
              <Table size={'small'}>
                <TableHeadCustom
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={tableData.length}
                  onSort={onSort}
                  sx={{
                    background: '#d4af37',
                  }}
                />
                <TableBody>
                  {(isLoading ? [...Array(rowsPerPage)] : tableData).map((row, index) =>
                    row ? (
                      <MyDownlineTableRow key={row.id} row={row} />
                    ) : (
                      !isNotFound && <TableSkeleton key={index} sx={{ height: denseHeight }} />
                    )
                  )}
                  <TableNoData isNotFound={isNotFound} />
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Box>
      </Box>
    </Page>
  );
};

export default MyDownline;
